import React from 'react'
import Grid from '@material-ui/core/Grid'
import NavigationList from '../components/NavigationList'
import { makeStyles } from '@material-ui/styles'
import { Route, Switch } from 'react-router'
import { ConnectedRouter } from 'connected-react-router'

import history from './history'
import { routes } from '../constants/routesConstants'
import NavigationDetails from '../components/NavigationDetails'
import TagDetails from '../components/TagDetails'
import { createIndexRoute, createStoreRoute } from './routeUtils'
import NavigationProductDetails from '../components/NavigationProductDetails'
import TagProductDetails from '../components/TagProductDetail'
import StoreSelector from '../components/StoreSelector'

const useStyles = makeStyles({
  container: {
    height: '100%'
  },
})

const DigitalMenuRoutes = () => {

  const classes = useStyles()

  return (
    <Grid container className={classes.container}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route exact path={createStoreRoute(routes.CATEGORY_PRODUCT())} component={NavigationProductDetails}/>
          <Route exact path={createStoreRoute(routes.CATEGORY())} component={NavigationDetails}/>
          <Route exact path={createStoreRoute(routes.TAG_PRODUCT())} component={TagProductDetails}/>
          <Route exact path={createStoreRoute(routes.TAG())} component={TagDetails}/>
          <Route exact path={createStoreRoute(routes.MENU())} component={NavigationList}/>
          <Route exact path={createIndexRoute()} component={StoreSelector}/>
        </Switch>
      </ConnectedRouter>
    </Grid>
  )
}

export default DigitalMenuRoutes
